/* Mushy · Stimmen
   Die Sektion blendet beim ersten Sichtbarwerden ein. Das Karussell selbst
   laeuft ueber mu-rail (assets/mu-rail.js). */

(function () {
  const reveal = (el) => {
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    // threshold 0.15 hat beim schnellen Vorbeiscrollen nicht ausgeloest: der
    // Beobachter meldet dann eine Lage, in der die Sektion schon oben raus ist,
    // und die Seite blieb 940px weiss. Deshalb Schwelle 0 und zusaetzlich
    // aufdecken, wenn die Sektion bereits ueber dem Bild liegt.
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting || e.boundingClientRect.top < 0) {
          el.classList.add('is-visible');
          io.disconnect();
        }
      });
    }, { threshold: 0 });
    io.observe(el);
  };

  const init = () => document.querySelectorAll('.mu-testimonials').forEach(reveal);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Der Theme-Editor rendert Sections neu, ohne die Seite zu laden.
  document.addEventListener('shopify:section:load', init);
})();
